export default __webpack_public_path__ + "static/media/hoverViewImage.09227c1c.svg";